import React from 'react';

// Small read-only rendering of a UoM Control Type's three controls — on
// controls colored/bold, off controls dimmed — so a Buy/Sell/Track
// combination is visible at a glance without having to remember what the
// Control Type's name implies. Shared between ProductUomPage (existing UoM
// rows) and ProductForm (the Control Type picker shown when adding a
// product's Base UoM).
function ControlFlags({ type }) {
  if (!type) return null;
  const flags = [
    { key: 'can_buy', label: 'Buy' },
    { key: 'can_sell', label: 'Sell' },
    { key: 'can_track', label: 'Track' },
  ];
  return (
    <span style={{ fontSize: 11 }}>
      {flags.map((f, idx) => (
        <span key={f.key}>
          <span style={{ color: type[f.key] ? '#2e7d32' : '#bbb', fontWeight: type[f.key] ? 600 : 400 }}>{f.label}</span>
          {idx < flags.length - 1 && <span style={{ color: '#ccc' }}> · </span>}
        </span>
      ))}
    </span>
  );
}

export default ControlFlags;
